import React, { FC } from 'react'

import { CloseIcon } from '../Icons/Close'

import { Overlay, InnerWrap, CloseButton, OuterWrap } from './styled'

type Props = {
  children: React.ReactNode
  isOpen: boolean
  onClose?: () => void
}

export const Modal: FC<Props> = ({ children, isOpen, onClose }) => {
  return (
    <OuterWrap isOpen={isOpen}>
      <Overlay isOpen={isOpen} onClick={onClose} />
      <InnerWrap>
        {children}
        {onClose && (
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        )}
      </InnerWrap>
    </OuterWrap>
  )
}
